import React from "react";
import styles from "./RecommendationFormStepHeader.module.scss";
import { CheckedOutlineIcon } from "../../../assets/icons";

type Props = {
    labelNextStep?: string
	labelBackStep?: string
};

const RecommendationFormStepHeader: React.FC<Props> = (props: Props) => {
    const { labelNextStep, labelBackStep } = props;

	return (
		<div className={styles.progressContainer}>
            {
                labelBackStep ?
                <div className={styles.leftSide}>
                    <CheckedOutlineIcon />
                    <div className={styles.textContainer}>
                        <div className={styles.stepText}>Previous Step</div>
                        <div className={styles.label}>{labelBackStep}</div>
                    </div>
                </div>
                : <div/>
            }
            {
                labelNextStep ?
                <div className={styles.rightSide}>
                    <div className={styles.textContainer}>
                        <div className={styles.stepText}>Next Step</div>
                        <div className={styles.label}>{labelNextStep}</div>
                    </div>
                </div>
                : <div/>
            }
		</div>
	);
};

export default RecommendationFormStepHeader;
